import { ModalSheet } from '@components/ModalSheet'
import { SupporterProfileContent } from '../components/SupporterProfileContent'
import type {
  SupporterShowQueryType,
  SupporterContactsQueryType,
  SupporterNotesQueryType,
} from '@frontend/graphql/queries/supporters'
import type { SmsConversationPage } from '../features/show-supporter/SmsConversation'
import type { EngagementLevelsIndexQueryType } from '@frontend/graphql/queries/engagementLevels'
import type { TagFiltersIndexQueryType } from '@frontend/graphql/queries/tagFilters'
import type { SharedInertiaProps } from '../types/supporterTypes'

type SupporterProfileSheetProps = {
  group: SupporterShowQueryType['group']
  contacts: SupporterContactsQueryType['contacts']
  supporterNotes: SupporterNotesQueryType['supporterNotes']
  supporterSmsMessages?: SmsConversationPage
  engagementLevels: EngagementLevelsIndexQueryType['engagementLevels']
  tagFilters: TagFiltersIndexQueryType['tagFilters']
} & SharedInertiaProps

function SupporterProfileSheet({
  group,
  contacts,
  supporterNotes,
  supporterSmsMessages,
  engagementLevels,
  tagFilters,
  permissions,
}: SupporterProfileSheetProps) {
  const supporterName = group.supporters.edges[0]?.node.fullName ?? ''

  return (
    <ModalSheet.Root reloadOnClose={['supporters']}>
      <ModalSheet.Header title={supporterName} />
      <ModalSheet.Body>
        <SupporterProfileContent
          group={group}
          contacts={contacts}
          supporterNotes={supporterNotes}
          supporterSmsMessages={supporterSmsMessages}
          engagementLevels={engagementLevels}
          tagFilters={tagFilters}
          permissions={permissions}
          reloadKeys={['group']}
        />
      </ModalSheet.Body>
    </ModalSheet.Root>
  )
}

export default SupporterProfileSheet
